module.exports = __webpack_public_path__ + "static/media/adult-blur-blurred-background-687824.ab4ad7da.png";